import { render } from "./historum.vue?vue&type=template&id=6c457ce4&scoped=true&lang=pug"
import script from "./historum.vue?vue&type=script&lang=js"
export * from "./historum.vue?vue&type=script&lang=js"

import "./historum.vue?vue&type=style&index=0&id=6c457ce4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c457ce4"]])

export default __exports__